const EVENT_TYPES_GTM = {
  initRegisteredSession: 'initRegisteredSession',
  login: 'login'
} as const;

export default EVENT_TYPES_GTM;
